import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import { headerHeight } from "@remo-co/ui-core/src/constants";

const ALERT_HEIGHT = 49;

export const useStyles = makeStyles<Theme>(({ spacing }) => ({
  geartestContainer: {
    minHeight: `calc(100vh - ${ALERT_HEIGHT + spacing(8) + headerHeight}px)`,
    position: "relative",
    top: `${-(ALERT_HEIGHT + spacing(8)) / 2}px`,
  },
  geartestAlert: {
    marginLeft: "auto",
    marginRight: "auto",
    width: "fit-content",
    marginTop: spacing(4),
    marginBottom: spacing(4),
  },

  mlAuto: {
    marginLeft: "auto",
  },
  overflowYAuto: {
    overflowY: "auto",
  },
}));
